import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const AddCrunchMappingModal = ({
    show,
    setShow,
    crunchCategories = {}, // { menu: [], labor: [], discount: [] }
    cbCoaCategories = {},  // { menu: [], labor: [], discount: [] }
    onAddMapping
}) => {
    const [categoryType, setCategoryType] = useState("menu"); // menu | labor | discount
    const [selectedCrunch, setSelectedCrunch] = useState("");
    const [selectedCbCoa, setSelectedCbCoa] = useState("");
    const [adding, setAdding] = useState(false);

    // Reset selections when category type changes
    useEffect(() => {
        setSelectedCrunch("");
        setSelectedCbCoa("");
    }, [categoryType]);

    const handleAdd = () => {
        if (!selectedCrunch || !selectedCbCoa) return; // validation
        setAdding(true);
        let cbId=flattenCategories(cbCoaCategories[categoryType] || [])?.find(c=>c?.value===selectedCbCoa?.trimStart())?.value
        onAddMapping({ crunchCategoryId: selectedCrunch, categoryId: cbId ,accountType:categoryType=="menu"?"SALE":categoryType?.toUpperCase()})
            ?.finally(() => setAdding(false));
    };

    const flattenCategories = (categories = [], level = 0) => {
        let result = [];
        categories.forEach(cat => {
            const indent = "\u00A0".repeat(level * 4); // 4 NBSPs per level (tweak as needed)
            result.push({
            value: cat.id|| cat.value,
            label: `${indent}${cat.label}`,
            level,
            type: cat.type
            });
            if (cat.children && cat.children.length) {
            result = result.concat(flattenCategories(cat.children, level + 1));
            }
        });
        return result;
        };
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New Crunch Mapping</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* ✅ Category Type Dropdown */}
                    <Form.Group className="mb-3">
                        <Form.Label>Category Type</Form.Label>
                        <Form.Select
                            value={categoryType}
                            onChange={(e) => setCategoryType(e.target.value)}
                        >
                            <option value="menu">Menu</option>
                            <option value="labor">Labor</option>
                            <option value="discount">Discount</option>
                        </Form.Select>
                    </Form.Group>

                    {/* ✅ Crunch Category Dropdown (Filtered by type) */}
                    <Form.Group className="mb-3">
                        <Form.Label>Crunch Category</Form.Label>
                        <Form.Select
                            value={selectedCrunch}
                            onChange={(e) => setSelectedCrunch(e.target.value)}
                        >
                            <option value="">Select Crunch Category</option>
                            {(crunchCategories[categoryType] || []).map(cat => (
                                <option key={cat.value} value={cat.value}>{cat.label}{cat.custom ? " (custom)" : ""}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    {/* ✅ CB CoA Dropdown (Filtered by type) */}
                    <Form.Group className="mb-3">
                        <Form.Label>clickBACON CoA</Form.Label>
                        <Form.Select
                            value={selectedCbCoa}
                            onChange={(e) => setSelectedCbCoa(e.target.value)}
                        >
                            <option value="">Select CB CoA</option>
                            {flattenCategories(cbCoaCategories[categoryType] || []).map(cat => (
                                <option
                                    key={cat.value}
                                    value={cat.value}
                                    style={{ paddingLeft: `${cat.level * 15}px` }} // indent children
                                >
                                    {cat.label}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>Cancel</Button>
                <Button variant="success" onClick={handleAdd} disabled={adding}>
                    {adding ? "Adding..." : "Add Mapping"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddCrunchMappingModal;
